<template>
  <v-navigation-drawer v-if="putNavigation"
                       v-model="navigation"
                       app
                       fixed
                       :temporary="temporary"
                       :dark="dark"
                       :right="right"
                       :color="color"
                       :bottom="isMobile ? bottom : false"
                       :style="styles"
                       class="d-flex overflow-hidden"
  >
    <Scroll ref="scroll" class="d-block flex-grow-1 " style="max-height: 100% !important;">
      <v-list>
        <v-list-item v-for="(section, index) in sections"
                     :id="`store-nav-${section.id}`"
                     :key="`${section.id}-${index}`"
                     :href="to(section.id)"
                     replace
                     text
                     block
                     tile
                     :class="mainClass(section)"
        >
          <v-list-item-title class="text-wrap">
            {{ section.name }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </Scroll>
    <template v-if="!readonly" v-slot:append>
      <v-list-item to="/address">
        <v-list-item-subtitle>
          <v-icon left>
            mdi-map-marker
          </v-icon>
          {{ $dictionary.get('change-address') }}
        </v-list-item-subtitle>
      </v-list-item>
    </template>
  </v-navigation-drawer>
</template>

<script>
import Scroll from '@/components/Scroll';

export default {
  name: 'Navigation',
  components: { Scroll },
  computed: {
    readonly() { return this.$store.state.data.settings.readonly; },
    dark() { return this.$store.state.theme.navigationDark; },
    temporary() {
      if (this.isMobile) return true;
      return this.$store.state.theme.navigationDesktop === 'temporary';
    },
    bottom() { return this.$store.state.theme.navigationBottom; },
    right() { return this.$store.state.theme.navigationRight; },
    color() { return this.$store.state.theme.navigationColor; },
    fullscreen() { return this.$store.state.ui.fullscreen; },
    navigation: {
      get() {
        if (!this.isMobile && this.$store.state.theme.navigationDesktop === 'constant') {
          return true;
        }
        return this.$store.state.ui.navigation;
      },
      set(val) { this.$store.commit('ui/navigation', val); },
    },
    sections() {
      return this.$store.state.data.sections;
    },
    sectionUI() {
      return this.$store.state.ui.section;
    },
    styles() {
      if (this.fullscreen && this.$vuetify.breakpoint.name !== 'xs') {
        return { 'max-height': '100%' };
      }
      return {};
    },
    menus() { return this.$store.state.data.menus; },
    putNavigation() {
      return true;
      // return !(Number(this.$store.state.data.settings.disable_navigation_aside));
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === 'xs';
    },

    catalogues() {
      const { points, point } = this.$store.state.data;
      return points[point].catalogues;
    }
  },
  watch: {
    sectionUI() {
      this.autoscrollExecute();
    }
  },
  mounted() {
    this.autoscrollExecute();
  },
  methods: {
    autoscrollExecute() {
      const el = document.getElementById(`store-nav-${this.sectionUI}`);
      if (el) {
        const container = this.$refs.scroll;
        this.$vuetify.goTo(el, { duration: 350, offset: 0, container });
      }
    },
    to: (section) => `#/showcase/${section}`,
    mainClass({ depth, id }) {
      return {
        'v-list-item--active': id === this.sectionUI,
        'font-weight-black': depth === 0,
        'ml-6': depth === 2,
        'ml-12': depth === 3,
        'text-caption': depth === 3,
        'ml-18': depth === 4,
        'ml-22': depth === 5,
      };
    },
    getRoot(catalogue) {
      return catalogue.content.find(({ root }) => root)
    }
  }
};
</script>
